import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  content: {
    display: "flex",
    padding: "30px",
  },
  contentLeft: {
    width: "45%",
  },
  draggableLabel: {
    marginTop: "30px",
  },
  draggableLabelSubtitle: {
    marginBottom: "15px",
  },
}));
